export const CART_KEYS = {
  SHOULD_CLEANUP: 'cart.shouldCleanup'
};
